import { TConversationStatus } from "src/data/guests/types/guestTypes"
import { useTranslate } from "src/i18n/useTranslate"
import {
  DropdownSelect,
  TSelectOption,
} from "src/ui/DropdownSelect/DropdownSelect"

export function GuestConversationStatusSelect({
  selectedValue,
  onChange,
}: {
  selectedValue: TConversationStatus
  onChange: (status: TConversationStatus) => void
}) {
  const { tPlaceholder } = useTranslate()

  function getOptionTranslations(status: TConversationStatus) {
    const translations: Record<TConversationStatus, string> = {
      resolved: tPlaceholder("Resolved"),
      unresolved: tPlaceholder("Unresolved"),
    }

    return translations[status]
  }

  const options: TSelectOption<TConversationStatus>[] = [
    { label: getOptionTranslations("resolved"), value: "resolved" },
    { label: getOptionTranslations("unresolved"), value: "unresolved" },
  ]

  return (
    <DropdownSelect<TConversationStatus>
      label={getOptionTranslations(selectedValue)}
      options={options}
      selectedValue={selectedValue}
      onChange={({ option }) => {
        onChange(option.value)
      }}
      mButtonVariant="secondary"
      color="neutral"
      size="x-small"
    />
  )
}
